import get from "lodash/get";
import { createSelector } from "reselect";
import * as AdNetwork from "constants/AdNetwork";

const getInitialAdConfig = (state) =>
  get(state, "story.ads.initial", {
    adTags: AdNetwork.DEFAULT_AD_NETWORK_URL,
  });

const getAdNetworkUrl = createSelector(
  getInitialAdConfig,
  (initialAdConfig) => initialAdConfig.adTags,
);

export default getAdNetworkUrl;
